import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import {
  HeartHandshake,
  CalendarClock,
  Gem,
  MessageCircle,
  UserCheck,
} from "lucide-react";

const services = [
  {
    title: "Ask a Question",
    category: "Query",
    icon: <MessageCircle className="w-6 h-6 text-purple-300" />,
    description:
      "Get expert answers to your specific questions about life, career, relationships and more",
    to: "/ask-question",
    gradient: "from-green-600 to-teal-600",
    buttonText: "Ask Now",
  },
  {
    title: "Kundli Matching",
    category: "Relationship",
    icon: <HeartHandshake className="w-6 h-6 text-purple-300" />,
    description:
      "Compare compatibility using traditional Guna Milan and Nakshatra matching techniques",
    to: "/kundli-matching",
    gradient: "from-pink-600 to-rose-600",
    buttonText: "Check Compatibility",
  },
  {
    title: "Shubh Muhurat",
    category: "Timing",
    icon: <CalendarClock className="w-6 h-6 text-purple-300" />,
    description:
      "Find auspicious timings for weddings, engagements, and important life events",
    to: "/shubh-muhurat",
    gradient: "from-yellow-600 to-orange-600",
    buttonText: "Find Best Time",
  },
  {
    title: "Marriage Relationship Consultation",
    category: "Consultation",
    icon: <Gem className="w-6 h-6 text-purple-300" />,
    description:
      "Get personalized astrological advice to build and sustain a successful marriage relationship",
    to: "/marriage-relationship-consultation",
    gradient: "from-rose-600 to-pink-600",
    buttonText: "Book Consultation",
  },
  {
    title: "Personalized Reading",
    category: "Guidance",
    icon: <Gem className="w-6 h-6 text-purple-300" />,
    description:
      "Receive in-depth, customized astrological readings tailored to your unique birth chart and life path for clarity and direction.",
    to: "/personalized-reading",
    gradient: "from-indigo-600 to-pink-600",
    buttonText: "Get My Reading",
  },
  {
    title: "Expert Astrologers",
    category: "Expert",
    icon: <UserCheck className="w-6 h-6 text-purple-300" />,
    description:
      "Connect with experienced astrologers for personalized guidance on relationships and life",
    to: "/experts",
    gradient: "from-indigo-600 to-purple-600",
    buttonText: "Connect with Experts",
  },
];



const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export default function ExploreVedic() {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isInView) {
          setIsInView(true);
        }
      },
      {
        threshold: 0.7, // 70%
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [isInView]);

  return (
    <div>
      <section className="py-0 mb-10 px-4" ref={ref}>
        <div className="max-w-7xl mx-auto">
          {/* <div className="text-center mb-12">
            <motion.h2
              className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4"
              variants={fadeUp}
            >
              Explore Vedic Wisdom
            </motion.h2>

            <motion.p
              className="text-lg text-purple-300 max-w-2xl mx-auto"
              variants={fadeUp}
          
            >
              Discover comprehensive astrology services designed to guide you
              through life's journey
            </motion.p>
          </div> */}

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map(
              (
                {
                  title,
                  category,
                  icon,
                  description,
                  to,
                  gradient,
                  buttonText,
                },
                index
              ) => (
                <motion.div
                  key={title}
                  className="rounded-lg border text-card-foreground shadow-sm bg-slate-800/50 border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:scale-105 cursor-pointer backdrop-blur-sm"
                  variants={fadeUp}
                  // initial="hidden"
                  // animate={isInView ? "visible" : "hidden"}
                  // transition={{ duration: 0.5, delay: 0.3 + index * 0.2 }}
                >
                  <div className="flex flex-col space-y-1.5 p-6 text-center">
                    <div className="flex items-center justify-between mb-2">
                      <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold bg-purple-600/20 text-purple-300 border-purple-500/30">
                        {category}
                      </div>
                      <div className="text-3xl">{icon}</div>
                    </div>
                    <h3 className="font-semibold tracking-tight text-xl text-purple-100">
                      {title}
                    </h3>
                  </div>
                  <div className="p-6 pt-0">
                    <p className="text-sm text-purple-300 mb-4 leading-relaxed">
                      {description}
                    </p>
                    <NavLink to={to}>
                      <button
                        className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r ${gradient} hover:opacity-90 text-white font-semibold`}
                      >
                        {buttonText}
                      </button>
                    </NavLink>
                  </div>
                </motion.div>
              )
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
